// extracted by mini-css-extract-plugin
module.exports = {"footer":"StrdrmFooter_footer__POzC0"};